module.exports = __webpack_public_path__ + "static/media/instagram-relax-mobile.2166e03b.webp";